import React, { useState } from 'react';
import styled from 'styled-components';
import { FaCalculator, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const LastreContainer = styled.div`
  margin: 10px 0;
  padding: 12px;
  background-color: rgba(15, 52, 96, 0.05);
  border-radius: 8px;
  border-left: 3px solid #e4312e;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
`;

const LastreHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  gap: 10px;
`;

const LastreTitle = styled.div`
  font-weight: 500;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  
  svg {
    margin-right: 8px;
    color: #e4312e;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const LastreValue = styled.div`
  font-weight: bold;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const LastreDetails = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 0.9rem;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    font-size: 0.85rem;
    margin-top: 8px;
    padding-top: 8px;
  }
`;

const DetailItem = styled.div`
  margin: 5px 0;
  padding: 8px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  width: 100%;
  box-sizing: border-box;
  
  &.positivo {
    border-left: 3px solid #28a745;
  }
  
  &.negativo {
    border-left: 3px solid #dc3545;
  }
  
  &.neutral {
    border-left: 3px solid #6c757d;
  }

  @media (max-width: 768px) {
    padding: 6px;
    margin: 4px 0;
    font-size: 0.8rem;
    line-height: 1.3;
  }
`;

interface LastreInfoProps {
  kgTotal: number;
  detalle: string[];
  darkMode?: boolean;
}

const LastreInfo: React.FC<LastreInfoProps> = ({ kgTotal, detalle, darkMode = false }) => {
  const [expanded, setExpanded] = useState(false);
  
  // Clasificar los detalles por tipo (positivo, negativo, neutral)
  const detallesProcesados = detalle.map(detalle => {
    let tipo = 'neutral';
    
    if (detalle.includes('Reducción') || detalle.includes('descarta')) {
      tipo = 'positivo';
    } else if (detalle.includes('Posición')) {
      tipo = 'neutral';
    }
    
    return { texto: detalle, tipo };
  });
  
  return (
    <LastreContainer style={{ 
      backgroundColor: darkMode ? 'rgba(15, 52, 96, 0.2)' : 'rgba(15, 52, 96, 0.05)',
      color: darkMode ? '#e0e0e0' : 'inherit'
    }}>
      <LastreHeader onClick={() => setExpanded(!expanded)}>
        <LastreTitle>
          <FaCalculator /> Lastre próxima carrera
        </LastreTitle>
        <LastreValue>
          {kgTotal} kg {expanded ? <FaChevronUp /> : <FaChevronDown />}
        </LastreValue>
      </LastreHeader>
      
      {expanded && (
        <LastreDetails>
          {detallesProcesados.map((detalle, index) => (
            <DetailItem key={index} className={detalle.tipo} style={{
              backgroundColor: darkMode ? 'rgba(30, 35, 64, 0.3)' : 'rgba(255, 255, 255, 0.5)'
            }}>
              {detalle.texto}
            </DetailItem>
          ))}
        </LastreDetails>
      )}
    </LastreContainer>
  );
};

export default LastreInfo;
